import { SessionStorageKeys } from '@consts';
import { SessionStorageService } from '@hooks/useSessionStorage';

export interface ImprvCoinsPurchaseContext {
  origin: string;
  // null = the pre-redirect snapshot fetch failed (distinct from [], a real empty history)
  knownAcquisitionIds: string[] | null;
  sku: string;
}

const sessionStorageService = SessionStorageService.getInstance();

export function saveImprvCoinsPurchaseContext(context: ImprvCoinsPurchaseContext): void {
  sessionStorageService.writeJson(SessionStorageKeys.IMPRV_COINS_PURCHASE, context);
}

export function readImprvCoinsPurchaseContext(): ImprvCoinsPurchaseContext | null {
  const parsed = sessionStorageService.readJson(SessionStorageKeys.IMPRV_COINS_PURCHASE) as Partial<
    Record<keyof ImprvCoinsPurchaseContext, unknown>
  > | null;
  if (
    typeof parsed?.origin !== 'string' ||
    typeof parsed?.sku !== 'string' ||
    !(parsed?.knownAcquisitionIds === null || Array.isArray(parsed?.knownAcquisitionIds))
  ) {
    return null;
  }
  return parsed as ImprvCoinsPurchaseContext;
}

export function clearImprvCoinsPurchaseContext(): void {
  sessionStorageService.remove(SessionStorageKeys.IMPRV_COINS_PURCHASE);
}
